import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'supportingDocumentType';

const supportingDocumentTypeService = {
  getItems: () => {
    return request({
      resource: `${baseURL}/data`,
    });
  },

  getExternalItems: () => {
    return request({
      resource: `${baseURL}/external`,
    });
  },

  getItemLinks: (itemCode) => {
    return request({
      resource: `${baseURL}/item/${encodeURIComponent(itemCode)}`,
    });
  },

  updateItemLinks: (itemCode, supportingDocumentTypeIds) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/item/${encodeURIComponent(itemCode)}`,
      data: { supportingDocumentTypeIds },
    });
  },

  getItem: (id) => {
    return request({
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: baseURL,
      formData: data instanceof FormData,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: baseURL,
      formData: data instanceof FormData,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  deleteReport: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/report/${encodeURIComponent(id)}`,
    });
  },
};

export default supportingDocumentTypeService;
